module.exports = __webpack_public_path__ + "img/744.2bd52475.jpg";